export * from './receipting-view.component';